import { useFormik } from "formik";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import * as Yup from "yup";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import $ from "jquery";

export default function Login({ saveUserData }) {
  const baseURL = "https://ecommerce.routemisr.com"; // or 'https://route-ecommerce-app.vercel.app'
  // validation manually
  // function validate(values) {
  //   let errors = {}
  //   if (!values.name) {
  //     errors.name = 'Name is Required'
  //   }else if (values.name.length < 3) {
  //     errors.name = 'Name minlength is 3 chars'
  //   }else if (values.name.length > 10) {
  //     errors.name = 'Name maxlength is 10 chars'
  //   }
  //   if (!values.email) {
  //     errors.email = 'Email is Required'
  //   }else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
  //     errors.email = 'Invalid email address *exemple@yyy.zzz';
  //   }
  //   if (!values.password) {
  //     errors.password = 'Password is required'
  //   } else if (!/^[A-Z][a-z0-9]{5-10}$/i.test(values.password)) {
  //     errors.password = 'Password must start with Capital Letter, at least 5 and less than 10 characters '
  //   }
  //   if (!values.rePassword) {
  //     errors.rePassword = 'Please reEnter Your Password'
  //   }else if (values.rePassword !== values.password) {
  //     errors.rePassword = 'Confirm password does not match'
  //   }
  //   if (!values.phone) {
  //     errors.phone = 'Phone is required'
  //   }else if (!/^01[0125][0-9]{8}$/i.test(values.phone)) {
  //     errors.phone = 'Phone must be valid Eg-number'
  //   }
  //   return errors
  // }
  const [loading, setloading] = useState(false);
  const [errMsg, seterrMsg] = useState(null);
  let navigate = useNavigate();

  async function handleLogin(values) {
    setloading(true);
    let { data } = await axios
      .post(`${baseURL}/api/v1/auth/signin`, values)
      .catch((err) => {
        setloading(false);
        seterrMsg(err.response.data.message);
      });
    if (data.message === "success") {
      setloading(false);
      localStorage.token = data.token;
      $(".successMsg").fadeIn(500, function () {
        saveUserData();
        navigate("/");
      });
    }
  }
  // Validation of entrie Email & Password
  let validationSchema = Yup.object({
    email: Yup.string()
      .required("Email is Required")
      .email("Invalid email address *exemple@yyy.zzz"),
    password: Yup.string()
      .required("Password is required")
      .matches(
        /^[A-Z][a-z0-9]{5,10}$/,
        "Password must start with Capital Letter includes at least 5 and less than 10 chars"
      ),
  });
  let formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema,
    onSubmit: handleLogin,
  });

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Sign in Now and Enjoy</title>
      </Helmet>

      <div className=" w-75 mx-auto py-4 ">
        <h3 className=" mb-3">Sign In :</h3>

        <form onSubmit={formik.handleSubmit}>
          {/* Handle Email with validation */}
          <label htmlFor="email">Email</label>
          <input
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.email}
            type="email"
            name="email"
            id="email"
            className=" form-control mb-2"
          />
          {formik.errors.email && formik.touched.email ? (
            <div className=" alert alert-danger">{formik.errors.email}</div>
          ) : null}

          {/* Handle Password with validation */}
          <label htmlFor="password">Password</label>
          <input
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.password}
            type="password"
            name="password"
            id="password"
            className=" form-control mb-2"
          />
          {formik.errors.password && formik.touched.password ? (
            <div className=" alert alert-danger">{formik.errors.password}</div>
          ) : null}

          {/* link if user forget password */}
          <Link
            className="d-block mt-2 hoveringClick mb-2"
            to="/forgetPassword"
          >
            Forgot your password?
          </Link>

          {/* Handle Error msg of inputs */}
          {errMsg ? <div className="alert alert-danger">{errMsg}</div> : null}

          {/* Handle Success msg if inputs valid */}
          <div
            style={{ display: "none" }}
            className="alert alert-success  successMsg"
          >
            Welcome Back <i className="fa-regular fa-thumbs-up"></i>
          </div>
          {loading ? (
            <button className="btn bg-main text-white mt-1" type="button">
              {" "}
              <i className="fa-solid fa-spinner fa-spin"></i>{" "}
            </button>
          ) : (
            <button
              disabled={!(formik.isValid && formik.dirty)}
              className="btn bg-main text-white mt-1"
              type="submit"
            >
              Sign In{" "}
            </button>
          )}
        </form>

        {/* link to register if user have no account */}
        <Link className="d-block mt-2 hoveringClick" to="/register">
          Do you have an account? Create account
        </Link>
      </div>
    </>
  );
}
